import { useNavigate } from 'react-router-dom';
import { BarChart3, CheckCircle2, Flame, Sparkles } from 'lucide-react';
import { type WeeklyStats } from '@/hooks/useDashboardData';

interface WeeklyMiniProgressCardProps {
  weekly: WeeklyStats;
}

const WeeklyMiniProgressCard = ({ weekly }: WeeklyMiniProgressCardProps) => {
  const navigate = useNavigate();

  const items = [
    {
      icon: CheckCircle2,
      text: `${weekly.checkinsCount} check-in${weekly.checkinsCount !== 1 ? 's' : ''} esta semana`,
      color: 'text-primary',
    },
    {
      icon: Flame,
      text: `${weekly.consecutiveProtocolDays} día${weekly.consecutiveProtocolDays !== 1 ? 's' : ''} consecutivos de protocolo`,
      color: 'text-wellness-peach',
    },
    {
      icon: Sparkles,
      text: weekly.bestSignal,
      color: 'text-wellness-purple',
    },
  ];

  return (
    <div className="bg-card rounded-2xl p-4 shadow-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-wellness-purple-light flex items-center justify-center">
            <BarChart3 className="h-3.5 w-3.5 text-wellness-purple" />
          </div>
          <h2 className="text-sm font-semibold">Tu semana</h2>
        </div>
        <button
          onClick={() => navigate('/app/progresso')}
          className="text-xs text-primary font-medium hover:underline"
        >
          Ver más
        </button>
      </div>
      <div className="space-y-2.5">
        {items.map((item, idx) => (
          <div key={idx} className="flex items-center gap-2.5">
            <item.icon className={`h-4 w-4 ${item.color} flex-shrink-0`} />
            <span className="text-sm text-muted-foreground">{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklyMiniProgressCard;
